import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  ASSOCIATE_ROLES_WITH_ACCOUNT,
  ASSOCIATE_ROLES_WITH_ACCOUNT_SUCCESS,
  ASSOCIATE_ROLES_WITH_ACCOUNT_FAILED,
} from '../../constants';

import { fetchAccountOverview } from '../../actions/account-actions';

import store from '../../store';

const associateRolesWithAccount = (action$, state$) =>
  action$.pipe(
    ofType(ASSOCIATE_ROLES_WITH_ACCOUNT),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.server}/accounts/${action.accountId}/roles?v=${
          process.env.REACT_APP_VERSION
        }`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
        body: JSON.stringify(action.payload),
        method: 'POST',
      }).pipe(
        map(response => {

          store.dispatch(fetchAccountOverview());
          return {
            type: ASSOCIATE_ROLES_WITH_ACCOUNT_SUCCESS,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: ASSOCIATE_ROLES_WITH_ACCOUNT_FAILED,
            error,
          })
        )
      )
    )
  );

export default associateRolesWithAccount;
